// extracted by mini-css-extract-plugin
module.exports = {"pagination__container":"styles_pagination__container__H_vER","is-active":"styles_is-active__iX_sA","is-disabled":"styles_is-disabled__41B3p"};